if (!customElements.get('cart-scrolling-text')) {
    const CartScrollingText = class extends HTMLElement {
        constructor() {
            super();
            window.initLazyScript(this, this.init.bind(this));
        }

        init() {
            this.track = this.querySelector('.cart-scrolling-text__track');
            this.lines = this.querySelectorAll('.cart-scrolling-text__line');
            this.currentIndex = 0;
            this.displayDuration = (parseFloat(this.dataset.displayDuration) || 4) * 1000;

            if (this.lines.length > 1) {
                if (this.dataset.pauseOnHover === 'true') {
                    this.addEventListener('mouseenter', this.pause.bind(this));
                    this.addEventListener('mouseleave', this.play.bind(this));
                }
                this.addEventListener('focusin', this.pause.bind(this));
                this.addEventListener('focusout', this.play.bind(this));
            }

            document.fonts.ready.then(() => {
                this.classList.add('cart-scrolling-text--ready');
                this.play();
            });
        }

        play() {
            if (this.lines.length <= 1 || this.interval) {
                return;
            }
            this.interval = setInterval(() => {
                this.currentIndex = (this.currentIndex + 1) % this.lines.length;
                this.track.style.setProperty('--cart-scrolling-text-index', this.currentIndex);
            }, this.displayDuration);
        }

        pause() {
            clearInterval(this.interval);
            this.interval = null;
        }
    };

    window.customElements.define('cart-scrolling-text', CartScrollingText);
}
